import React, { useEffect } from 'react';
import AOS from 'aos';
import './Skills.css';

const skills = {
  Languages: ['JavaScript', 'Python', 'PHP', 'Java'],
  Databases: ['MySQL', 'MongoDB', 'PostgreSQL'],
  'Web Technologies': [ 'HTML', 'CSS/SCSS', 'JavaScript', 'React JS', 'React-Native', 'TypeScript', 'Bootstrap', 'REST API', 'jQuery'],
  Frameworks: ['React', 'Express', 'Node', 'Flask', 'Django', 'Laravel', 'Spring Boot'],
  'Tools': [ 'Git', 'GitHub', 'Jupyter Notebook', 'Google Colab', 'Scikit-Learn', 'AWS', 'Tableau', 'Adobe Illustrator', 'Adobe XD', 'Figma'],
};

const Skills = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <div className="skills" id="skills">
      <div className="container">
        <span
          className="l-skills"
          data-aos="fade-right"
          data-aos-once="true"
          data-aos-delay="500"
        >
          Skills
        </span>
        <div className="skills_box">
          <h2 data-aos="fade-up" data-aos-once="true" data-aos-delay="100">
            My skills
          </h2>
          {Object.entries(skills).map(([category, items], index) => (
            <div key={category}>
              <h5
                data-aos="fade-up"
                data-aos-once="true"
                data-aos-delay={200 + index * 100}
              >
                {category}
              </h5>
              <div
                className="skill-badges"
                data-aos="fade-up"
                data-aos-once="true"
                data-aos-delay={250 + index * 100}
              >
                {items.map((skill) => (
                  <span className="badge" key={skill}>
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
